<script setup>
import { ref } from "vue"

import Layout from "../../layouts/main.vue"
import PageHeader from "@/components/page-header"

import store from "../../state/store"
import BannerModal from "./BannerModal.vue"
import BannerEditModal from "./BannerEditModal.vue"
import BannersTable from "./BannersTable.vue"

const title = "مدیریت بنرهای تبلیغاتی"
const items = ref([
  {
    text: "داشبورد",
    href: "/",
  },
  {
    text: "مدیریت بنرهای تبلیغاتی",
    active: true,
  },
])

const DEFAULT_BANNER = {
  id: "",
  ads_title: "",
  ads_link: "",
  ads_image: "",
  status: "",
}

const bannerModel = ref({ ...DEFAULT_BANNER })
const showBannerModal = ref(false)
const showBannerEditModal = ref(false)

const showAddNewModal = () => {
  showBannerModal.value = true
}

const showEditModal = () => {
  showBannerEditModal.value = true
}

function editBanner(bnr) {
  store.dispatch("getBanner", bnr.id).then(({ data }) => {
    bannerModel.value = data.data
    showEditModal()
  })
}

const onModalClose = () => {
  bannerModel.value = { ...DEFAULT_BANNER }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-row>
      <b-col lg="12">
        <b-card no-body id="bannerList">
          <b-card-header class="border-bottom-dashed">
            <b-row class="g-4 align-items-center">
              <b-col sm>
                <div>
                  <h5 class="card-title mb-0">لیست بنرهای تبلیغاتی</h5>
                </div>
              </b-col>
              <b-col sm="auto">
                <div class="d-flex flex-wrap align-items-start gap-2">
                  <b-button
                    type="button"
                    variant="success"
                    class="add-btn me-1"
                    id="create-btn"
                    @click="showAddNewModal()"
                  >
                    <i class="ri-add-line align-bottom me-1"></i> افزودن بنرهای
                    تبلیغاتی جدید
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-card-header>

          <!-- banners table  -->

          <BannersTable @clickEdit="editBanner" />

          <!-- add and edit banner modal  -->

          <BannerModal
            v-model="showBannerModal"
            :banner="bannerModel"
            @close="onModalClose"
          />

          <BannerEditModal
            v-model="showBannerEditModal"
            :banner="bannerModel"
            @close="onModalClose"
          />
        </b-card>
      </b-col>
    </b-row>
  </Layout>
</template>

<style>
.multiselect-clear {
  padding: 0 0 0 var(--ms-px, 0.875rem) !important;
}
.multiselect-caret {
  margin: 0 0 0 var(--ms-px, 0.875rem) !important;
}

.form-select {
  display: block;
  width: 100%;
  padding: 0.5rem 0.9rem 0.5rem 2.7rem !important;
  background-position: left 0.9rem center !important;
}

.invalid-feedback {
  display: block !important;
}
</style>
